import { dateTimeTypePolicy } from "./scalar-types";

export const scalarTypePolicies = {
  Beneficiary: {
    fields: { createdAt: dateTimeTypePolicy, terminatedAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  BeneficiaryDelivery: {
    fields: { approvedAt: dateTimeTypePolicy, receivedAt: dateTimeTypePolicy, stagedAt: dateTimeTypePolicy },
  },
  BeneficiaryTransactionSet: { fields: { receivedAt: dateTimeTypePolicy } },
  CaseRecommendation: { fields: { generatedAt: dateTimeTypePolicy } },
  CaseRoom: { fields: { openedAt: dateTimeTypePolicy, snapshotAt: dateTimeTypePolicy } },
  CaseRoomTurn: { fields: { finishedAt: dateTimeTypePolicy, startedAt: dateTimeTypePolicy } },
  CrawlDocumentCount: { fields: { firstSavedAt: dateTimeTypePolicy, lastSavedAt: dateTimeTypePolicy } },
  CrawlProgress: { fields: { endedAt: dateTimeTypePolicy, startedAt: dateTimeTypePolicy } },
  EligibilityInspection: { fields: { ranAt: dateTimeTypePolicy } },
  EligibilityInspectionSnapshot: { fields: { storedAt: dateTimeTypePolicy } },
  EligibilityOpsUser: { fields: { enrolledAt: dateTimeTypePolicy, lastCheckedAt: dateTimeTypePolicy } },
  ExecutionResultArtifact: { fields: { createdAt: dateTimeTypePolicy } },
  InsuranceCheckStatus: { fields: { lastAnsweredAt: dateTimeTypePolicy, lastAttemptAt: dateTimeTypePolicy } },
  InsuranceMembership: { fields: { confirmedAt: dateTimeTypePolicy } },
  InsurancePosition: { fields: { lastChangedAt: dateTimeTypePolicy } },
  InsurancePositionReading: { fields: { observedAt: dateTimeTypePolicy } },
  NateraIntakeActivation: { fields: { reminderAt: dateTimeTypePolicy } },
  OpenCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  Partner: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PartnerGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ResourceSnapshotResult: { fields: { computedAt: dateTimeTypePolicy } },
  RpaForecastEntry: { fields: { dispatchAt: dateTimeTypePolicy } },
  RpaLinkView: { fields: { createdAt: dateTimeTypePolicy, lastSessionAt: dateTimeTypePolicy } },
  RpaSessionDot: { fields: { startedAt: dateTimeTypePolicy } },
  SatisfiedCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  StaffTailgateAsk: { fields: { expiresAt: dateTimeTypePolicy } },
  StaffTailgateFile: { fields: { takenAt: dateTimeTypePolicy } },
  StaffTailgateStep: { fields: { at: dateTimeTypePolicy } },
  StaffTailgateView: { fields: { holdUntil: dateTimeTypePolicy } },
  UnattestedCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  UserHealthRecord: { fields: { updatedAt: dateTimeTypePolicy } },
  UserUploadedDocumentsResult: { fields: { createdAt: dateTimeTypePolicy } },
  WebAgentExecutionResult: { fields: { createdAt: dateTimeTypePolicy } },
};
